import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './phoneFilter.json';

const queryBlackListSetting = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['phoneFilterController/queryBlackListSetting'].success.default)));
};

const updateBlackListSetting = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['phoneFilterController/updateBlackListSetting'].success.default)));
};

export const handlers = [
  rest.post(
    getApiEndpoint('PhoneFilterController/queryBlackListSetting'),
    withScenario(withAuthCheck(queryBlackListSetting))
  ),
  rest.post(
    getApiEndpoint('PhoneFilterController/updateBlackListSetting'),
    withScenario(withAuthCheck(updateBlackListSetting))
  ),
];
